import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "grid items-start grid-cols-12 gap-x-6 gap-y-3"
}
const _hoisted_3 = { class: "grid items-start grid-cols-6 col-span-12 md:col-span-6 gap-x-6 gap-y-3" }
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 text-xs font-medium text-neutral-500" }, " Fullname ", -1)
const _hoisted_6 = { class: "mb-1 text-sm font-bold" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 text-xs font-medium text-neutral-500" }, " Social Worker ", -1)
const _hoisted_9 = { class: "mb-1 text-sm font-bold" }
const _hoisted_10 = { class: "col-span-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 text-xs font-medium text-neutral-500" }, " CPU Invitees ", -1)
const _hoisted_12 = { class: "pl-5 mb-1 text-sm font-bold" }
const _hoisted_13 = { class: "grid items-start grid-cols-6 col-span-12 md:col-span-6 gap-x-6 gap-y-3" }
const _hoisted_14 = { class: "col-span-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 text-xs font-medium text-neutral-500" }, " CPU Case No. ", -1)
const _hoisted_16 = { class: "mb-1 text-sm font-bold" }
const _hoisted_17 = { class: "col-span-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 text-xs font-medium text-neutral-500" }, " Date and Time ", -1)
const _hoisted_19 = { class: "mb-1 text-sm font-bold" }
const _hoisted_20 = { class: "col-span-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 text-xs font-medium text-neutral-500" }, " Other Agencies ", -1)
const _hoisted_22 = { class: "pl-5 mb-1 text-sm font-bold" }
const _hoisted_23 = { class: "col-span-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 text-xs font-medium text-neutral-500" }, " Recommendations ", -1)
const _hoisted_25 = { class: "pl-5 mb-1 text-sm font-bold" }
const _hoisted_26 = {
  key: 0,
  class: "w-full text-xs font-medium text-center text-gray-400"
}
const _hoisted_27 = { class: "col-span-12 lg:col-span-2 md:col-span-4" }
const _hoisted_28 = { class: "lg:col-span-6 col-span-12 border lg:rounded-2xl rounded-lg border-neutral-100 flex flex-col min-h-[250px]" }
const _hoisted_29 = { class: "flex items-center justify-between p-6 border-b border-neutral-100" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-900" }, "CPU Invitees ", -1)
const _hoisted_31 = {
  key: 0,
  class: "text-[10px] mt-1 text-red-600 text-center",
  id: "email-error"
}
const _hoisted_32 = { class: "pr-4 text-sm font-medium text-gray-500" }
const _hoisted_33 = { class: "flex space-x-3 shrink-0" }
const _hoisted_34 = {
  key: 1,
  class: "flex items-center justify-between h-full px-6 py-3"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "w-full text-xs font-medium text-center text-gray-400" }, "No Selected", -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "lg:col-span-6 col-span-12 border lg:rounded-2xl rounded-lg border-neutral-100 flex flex-col min-h-[250px]" }
const _hoisted_38 = { class: "flex items-center justify-between p-6 border-b border-neutral-100" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-900" }, "Other Agencies ", -1)
const _hoisted_40 = {
  key: 0,
  class: "text-[10px] mt-1 text-red-600 text-center",
  id: "email-error"
}
const _hoisted_41 = { class: "pr-4 text-sm font-medium text-gray-500" }
const _hoisted_42 = { class: "flex space-x-3 shrink-0" }
const _hoisted_43 = {
  key: 1,
  class: "flex items-center justify-between h-full px-6 py-3"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "w-full text-xs font-medium text-center text-gray-400" }, "No Selected", -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  key: 0,
  class: "col-span-12 p-6 border rounded-2xl border-neutral-100"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3 font-semibold text-gray-900" }, "Recommendations", -1)
const _hoisted_48 = { class: "flex flex-col pl-5 space-y-4" }
const _hoisted_49 = {
  key: 0,
  class: "w-full text-xs font-medium text-center text-gray-400"
}
const _hoisted_50 = { class: "flex flex-col space-y-2" }
const _hoisted_51 = { class: "flex flex-col space-y-6" }

import { ref, onMounted, computed, watch } from "vue";
import TextInput from "@/components/inputs/TextInput.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import { PencilSquareIcon, XMarkIcon } from "@heroicons/vue/24/solid";
import ContentModal from "../Component/ContentModal.vue";
import DateFormatter from "@/helpers/DateFormatter";
import SuccessModal from '@/components/modals/SuccessModal.vue';
import AgencyRules from "@/classes/Cases/CaseConference/Rules/AgencyRules";
import useVuelidate from "@vuelidate/core";
import ErrorValidation from "@/views/interventions/Components/Classess/ErrorValidation";


export default /*#__PURE__*/_defineComponent({
  __name: 'InformationTab',
  props: {
    createMode: {
        type: Boolean,
        default: false
    },
    editMode: {
        type: Boolean,
        default: false
    },
    form: {
        type: Object,
        required: true
    },
    isEdit: {
        type: Boolean,
        default: false
    },
    isCreate: {
        type: Boolean,
        default: true
    },
    errors: {
        type: Object,
        required: true
    },
    canRefresh: {
        type: Boolean,
        default: false,
    },
    agencies: {
        type: Object,
        required: true
    },
    invitees: {
        type: Object,
        required: true
    },
    socialWorkers: {
        type: Object,
        required: true
    },
    recommendations: {
        type: Object,
        required: true
    },
    item: {
        type: Object,
        required: true
    },
},
  emits: ['setInvitees', 'setAgencies', 'setView', 'update:form'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const form = ref(props.form)

const showCPUInviteesModal = ref<boolean>(false);
const showOtherAgenciesModal = ref<boolean>(false);

const showSuccessSave = ref(false);

const inviteeIds = ref<any[]>(props.inviteeIds ?? [])
console.log(inviteeIds.value);
const selectedInvitees = ref([])
const selectedAgencies = ref([])

const isEdit = computed(() => props.isEdit)
const isEditAgency = ref(false)
const editAgencyIndex = ref<any>(null)

const recommendations = ref(props.recommendations)

const agencyForm = ref({
    agency_id: null,
    name: null
})

const { createRule } = AgencyRules;
const errorMessage = ref({});

// Sample
const allowToFill = ref<boolean>(true);

const updateInvitees = (id: number, index: number, isChecked: boolean): void => {
	if (isChecked) {
		inviteeIds.value.push(id)
	}
	if (!isChecked) {
        inviteeIds.value = inviteeIds.value.filter((item: number) => item != id);
	}
};

const setInvitees = () => {
    selectedInvitees.value = props.invitees.filter(x => inviteeIds.value.includes(x.id))
    showCPUInviteesModal.value = false
    emit('setInvitees', inviteeIds.value)
}

const removeInvitee = (id: number, index: number) => {
    const indx = inviteeIds.value.indexOf(id)

    if (indx !== -1) {
        inviteeIds.value.splice(indx, 1)
        emit('setInvitees', inviteeIds.value)
    }
    selectedInvitees.value.splice(index, 1)
}

/**
 * Validate the form using Vuelidator
 */
 const validateForm = async () =>{
	const vuelidate = useVuelidate(createRule({...form.value}), agencyForm.value)
	const result = await vuelidate.value.$validate();

    if (result) {
        return null;
    } else {
        errorMessage.value = ErrorValidation.getErrors(vuelidate.value);
        return errorMessage.value;
    }
}

const setAgencies = async () => {
    // Set validation rule for Online and Offline
    const validate = await validateForm();
    if (validate) {
        return;
    }

    if (!isEditAgency.value) {
        selectedAgencies.value.push({...agencyForm.value})
        agencyForm.value.agency_id = null
        agencyForm.value.name = null
    } else {
        selectedAgencies.value[editAgencyIndex.value].agency_id = agencyForm.value.agency_id
        selectedAgencies.value[editAgencyIndex.value].name = agencyForm.value.name

        agencyForm.value.agency_id = null
        agencyForm.value.name = null
    }

    emit('setAgencies', selectedAgencies.value)
    isEditAgency.value = false
    showOtherAgenciesModal.value = false
}

const removeAgency = (index: number) => {
    selectedAgencies.value.splice(index, 1)
}

const editAgency = (item: any, index: number) => {
    isEditAgency.value = true
    editAgencyIndex.value = index
    showOtherAgenciesModal.value = true
    agencyForm.value.agency_id = item.agency_id
    agencyForm.value.name = item.name  
}

const getAgencyName = (id:any) => {
    const agency = props.agencies.find((x:any) => x.id === id);
    return agency ? agency.label : null;
};

const initItems = () => {
    inviteeIds.value = props.item.invitees
    
    selectedInvitees.value = props.invitees.filter((x:any) => inviteeIds.value?.includes(x.id))
    
    selectedAgencies.value = props.item.agencies
}

watch(
    () => props.item,
    (value) => {
        if (value) {
            inviteeIds.value = value.invitees
            selectedInvitees.value = props.invitees.filter(x => inviteeIds.value.includes(x.id))

            selectedAgencies.value = value.agencies
        }
    }
)

watch(
    form.value,
    () => {
        emit('update:form', form.value);
    }
);

onMounted(() => initItems());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isEdit.value && !__props.isCreate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", _hoisted_6, _toDisplayString(__props.item?.patient_name), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("p", _hoisted_9, _toDisplayString(__props.item?.social_worker), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("ol", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item?.invitees_formatted, (i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "list-decimal",
                    key: i
                  }, _toDisplayString(i.name), 1))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("p", _hoisted_16, _toDisplayString(__props.item?.case_conference_number), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(DateFormatter).defaultTimeStamp(__props.item?.date_time)), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("ol", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item?.agencies_formatted, (i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "list-decimal",
                    key: i
                  }, _toDisplayString(i.name), 1))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("ul", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendations.value, (recommendation) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "list-disc",
                  key: recommendation
                }, _toDisplayString(recommendation), 1))
              }), 128))
            ]),
            (recommendations.value?.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_26, "No Recommendations"))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (isEdit.value || __props.isCreate)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["grid grid-cols-12 gap-6", !isEdit.value && !__props.isCreate ? 'cursor-not-allowed' : ''])
        }, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(TextInput, {
              type: "number",
              label: "Conference No.",
              placeholder: "Conference No.",
              name: "conference_number",
              id: "conference_number",
              disabled: true,
              modelValue: form.value.case_conference_number,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.case_conference_number) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["col-span-12 lg:col-span-3 md:col-span-4", !isEdit.value && !__props.isCreate ? 'pointer-events-none' : ''])
          }, [
            _createVNode(MultiSelect, {
              options: __props.socialWorkers,
              label: "Social Worker",
              id: "social_worker",
              name: "social_worker",
              placeholder: "Select..",
              searchable: "",
              required: "",
              modelValue: form.value.social_worker_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.social_worker_id) = $event)),
              error: __props.errors?.social_worker_id
            }, null, 8, ["options", "modelValue", "error"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-span-12 lg:col-span-3 md:col-span-4", !isEdit.value ? 'pointer-events-none' : ''])
          }, [
            (_openBlock(), _createBlock(DatePicker, {
              id: "date_and_time",
              name: "date_and_time",
              label: "Date and Time",
              key: form.value.date_time,
              required: "",
              enableTimePicker: true,
              timePickerInline: true,
              modelValue: form.value.date_time,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.date_time) = $event)),
              error: __props.errors?.date_time
            }, null, 8, ["modelValue", "error"]))
          ], 2),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(ButtonComponent, {
                class: _normalizeClass(!isEdit.value ? 'pointer-events-none' : ''),
                size: "small",
                customClass: "quaternary",
                disabled: !allowToFill.value,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showCPUInviteesModal.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Add ")
                ]),
                _: 1
              }, 8, ["class", "disabled"])
            ]),
            (__props.errors)
              ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(__props.errors?.invitees), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedInvitees.value, (i, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "flex items-center justify-between px-6 py-3 odd:bg-gray-50"
              }, [
                _createElementVNode("p", _hoisted_32, _toDisplayString(i.label), 1),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", {
                    class: _normalizeClass(!isEdit.value ? 'cursor-not-allowed' : '')
                  }, [
                    _createVNode(_unref(XMarkIcon), {
                      class: _normalizeClass([!isEdit.value ? 'pointer-events-none' : '', "w-5 h-5 text-gray-900 transition hover:text-red-500"]),
                      "aria-hidden": "true",
                      onClick: ($event: any) => (removeInvitee(i.id, index))
                    }, null, 8, ["class", "onClick"])
                  ], 2)
                ])
              ]))
            }), 128)),
            (selectedInvitees.value?.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createVNode(ButtonComponent, {
                class: _normalizeClass(!isEdit.value ? 'pointer-events-none' : ''),
                size: "small",
                customClass: "quaternary",
                disabled: !allowToFill.value,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showOtherAgenciesModal.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Add ")
                ]),
                _: 1
              }, 8, ["class", "disabled"])
            ]),
            (__props.errors)
              ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(__props.errors?.agencies), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedAgencies.value, (i, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "flex items-center justify-between px-6 py-3 odd:bg-gray-50"
              }, [
                _createElementVNode("p", _hoisted_41, _toDisplayString(i.name) + " - " + _toDisplayString(getAgencyName(i.agency_id)), 1),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("button", {
                    class: _normalizeClass(!isEdit.value ? 'cursor-not-allowed' : '')
                  }, [
                    _createVNode(_unref(PencilSquareIcon), {
                      class: _normalizeClass([!isEdit.value ? 'pointer-events-none' : '', "w-5 h-5 text-gray-900 transition hover:text-secondary-500"]),
                      "aria-hidden": "true",
                      onClick: ($event: any) => (editAgency(i, index))
                    }, null, 8, ["class", "onClick"])
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(!isEdit.value ? 'cursor-not-allowed' : '')
                  }, [
                    _createVNode(_unref(XMarkIcon), {
                      class: _normalizeClass([!isEdit.value ? 'pointer-events-none' : '', "w-5 h-5 text-gray-900 transition hover:text-red-500"]),
                      "aria-hidden": "true",
                      onClick: ($event: any) => (removeAgency(index))
                    }, null, 8, ["class", "onClick"])
                  ], 2)
                ])
              ]))
            }), 128)),
            (selectedAgencies.value?.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
              : _createCommentVNode("", true)
          ]),
          (recommendations.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("ul", _hoisted_48, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendations.value, (recommendation) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "text-sm font-medium text-gray-500 list-disc",
                      key: recommendation
                    }, _toDisplayString(recommendation), 1))
                  }), 128)),
                  (recommendations.value?.length === 0 )
                    ? (_openBlock(), _createElementBlock("li", _hoisted_49, "No Recommendations"))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(ContentModal, {
            show: showCPUInviteesModal.value,
            title: "Select CPU Invitees"
          }, {
            button: _withCtx(() => [
              _createVNode(ButtonComponent, {
                btnWidth: "quinary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (showCPUInviteesModal.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancel ")
                ]),
                _: 1
              }),
              _createVNode(ButtonComponent, {
                customClass: "primary",
                onClick: setInvitees
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Save Changes ")
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_50, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.invitees, (item, index) => {
                  return (_openBlock(), _createBlock(CheckboxInput, {
                    key: index,
                    checked: inviteeIds.value.includes(item.id),
                    id: 'invitee' + index,
                    name: 'invitee' + index,
                    label: item.label,
                    "onUpdate:modelValue": (value) => updateInvitees(item.id, index, value)
                  }, null, 8, ["checked", "id", "name", "label", "onUpdate:modelValue"]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(ContentModal, {
            show: showOtherAgenciesModal.value,
            title: "Select Other Agencies",
            showInformation: true,
            showInformationText: "Go to setting to add another “other agency”"
          }, {
            button: _withCtx(() => [
              _createVNode(ButtonComponent, {
                btnWidth: "quinary",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (showOtherAgenciesModal.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancel ")
                ]),
                _: 1
              }),
              _createVNode(ButtonComponent, {
                customClass: "primary",
                onClick: setAgencies
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Add ")
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_51, [
                _createVNode(MultiSelect, {
                  options: __props.agencies,
                  label: "Other Agencies",
                  id: "other_agencies",
                  name: "other_agencies",
                  placeholder: "Select..",
                  searchable: "",
                  modelValue: agencyForm.value.agency_id,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((agencyForm.value.agency_id) = $event)),
                  required: "",
                  error: errorMessage.value.agency_id
                }, null, 8, ["options", "modelValue", "error"]),
                _createVNode(TextInput, {
                  label: "Name",
                  placeholder: "Name",
                  name: "name",
                  id: "name",
                  modelValue: agencyForm.value.name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((agencyForm.value.name) = $event)),
                  required: "",
                  error: errorMessage.value.name
                }, null, 8, ["modelValue", "error"])
              ])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(SuccessModal, {
            noBtn: "",
            show: showSuccessSave.value,
            "action-text": "Close",
            title: "Record Save",
            content: "Case Conference has been updated"
          }, null, 8, ["show"])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})